<template>
    <v-container
        :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
        :style="$vuetify.theme.dark ? 'text-shadow:1px 1px 3px #000, 1px 1px 3px #222;' : 'text-shadow:1px 1px 3px #fff, 1px 1px 3px #eeecec;'"
    >
        <div v-if="toplist.length > 0" style="overflow-x: auto;">
            <v-simple-table class="transparent" style="max-height: 100vh;">
                <template v-slot:default>
                    <thead>
                        <tr :class="$vuetify.theme.dark ? 'transparent06--dark' : 'transparent06'">
                            <th v-for="(header, headerIndex) in headers" :key="header" class="text-left" :class="{'text-center': keys[headerIndex]==='created'}">
                                {{ header }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(item, indexPlayer) in toplist"
                            :key="item.id"
                            :class="{
                                'transparent04': !$vuetify.theme.dark && indexPlayer % 2 === 0,
                                'transparent06': !$vuetify.theme.dark && indexPlayer % 2 === 1,
                                'transparent04--dark': $vuetify.theme.dark && indexPlayer % 2 === 0,
                                'transparent06--dark': $vuetify.theme.dark && indexPlayer % 2 === 1,
                                'text-bold': isPlayer(1+indexPlayer),
                            }"
                        >
                            <td v-for="(key, index) in keys" :key="index" :class="{'text-right': key==='index' || key==='created'}">
                                <span v-if="key==='index'">{{ 1+indexPlayer + '.'}}</span>
                                <span v-else-if="key==='trainer'">{{ item.trainer.name }}</span>
                                <span v-else-if="key==='created'">{{ (new Date(item.created)).toLocaleDateString("cs-CZ") }}</span>
                                <span v-else>{{ item[key] }}</span>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot v-if="actualTrainer && actualTrainer.rank > 10">
                        <tr class="text-center">
                            <td :colspan="keys.length">
                                <b>{{ $t('journey.toplistTable.youLabel') }}</b>
                            </td>
                        </tr>
                        <tr
                            :class="$vuetify.theme.dark ? 'transparent06--dark' : 'transparent06'"
                            style="position: -webkit-sticky; position: sticky; bottom: 0px"
                        >
                            <td v-for="(key, index) in keys" :key="index" :class="{'text-right': key==='index' || key==='created'}">
                                <span v-if="key==='index'">{{ actualTrainer.rank + '.'}}</span>
                                <span v-else-if="key==='trainer'">{{ actualTrainer.result.trainer.name }}</span>
                                <span v-else-if="key==='created'">{{ (new Date(actualTrainer.result.created)).toLocaleDateString("cs-CZ") }}</span>
                                <span v-else>{{ actualTrainer.result[key] }}</span>
                            </td>
                        </tr>
                    </tfoot>
                </template>
            </v-simple-table>
        </div>
    </v-container>
</template>

<script>
    export default {
        name: 'ToplistTable',
        props: {
            toplist: {type: Array, default: () => []},
            actualTrainer: {type: Object, default: () => null},
            headers: {type: Array, default: () => []},
            keys: {type: Array, default: () => []},
        },
        methods: {
            isPlayer(index) {
                return this.actualTrainer && index === this.actualTrainer.rank;
            },
        },
    }
</script>

<style lang="scss">
tbody {
    tr:hover {
        background-color: transparent !important;
    }
}
</style>
